import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './layout/Layout';
import Home from './pages/Home';
import DepositInfo from './pages/DepositInfo';
import Deposit from './pages/Deposit';
import { Web3Provider } from './contexts/WalletContext';
import { AuthProvider } from './contexts/AuthContext';
import { Navigate } from 'react-router-dom';

function App() {
  return (
    <Web3Provider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              {/* <Route path="deposit-info" element={<DepositInfo />} /> */}
              {/* <Route path="deposit" element={<Deposit />} /> */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </Web3Provider>
  );
}

export default App;
